import upsertThreadContentItem from '@/lib/threads/upsertThreadContentItem.js';
import ensureThreadContentItem from './ensureThreadContentItem.js';

const rollbackConnectionOutcome = (state, payload) => {
  const { threadId, interactionId } = payload.meta;
  const ensured = ensureThreadContentItem({ state, threadId });

  if (!ensured) {
    return state;
  }

  const activity = (ensured.threadContentItem.activity || []).map((item) => {
    if ((item.interactionId || item.id) !== interactionId || item.outcome !== payload.outcome) {
      return item;
    }

    return { ...item, outcome: null, respondedAt: null };
  });

  return { ...state, threadContent: upsertThreadContentItem(ensured.threadContent, { ...ensured.threadContentItem, activity }) };
};

export default rollbackConnectionOutcome;
